// Particular
export const PARTICULAR_PLAN_GROUP_CODE = 'TELAVITA'

// Enterprise (Rede - Operadoras de saúde)
export const ALICE_PLAN_GROUP_CODE = 'ALICE'
export const BRADESCO_SAUDE_PLAN_GROUP_CODE = 'GPL01013'
export const BRADESCO_SEGUROS_PLAN_GROUP_CODE = 'BRADSEGU'
export const CAREPLUS_PLAN_GROUP_CODE = 'GPL01001'
export const CASSI_PLAN_GROUP_CODE = 'CASSI'
export const CUIDAR_OMINT_PLAN_GROUP_CODE = 'CUIDOMIN'
export const MEDISERVICE_PLAN_GROUP_CODE = 'MEDISERV'
export const OMINT_PLAN_GROUP_CODE = 'GPL01008'
export const PROGRAMA_VIVA_PLAN_GROUP_CODE = 'GPL01012'
export const SAMI_PLAN_GROUP_CODE = 'SAMISAUD'
export const SANTA_HELENA_GROUP_CODE = 'SANTHELE'
export const SAUDEID_PLAN_GROUP_CODE = 'SAUDEID'
export const SOMPO_PLAN_GROUP_CODE = 'SOMPO'
export const UNIMED_ANHANGUERA_PLAN_GROUP_CODE = 'UNIMANHA'
export const UNIMED_NOROESTE_PLAN_GROUP_CODE = 'UNIMNORO'
export const UNIMED_LONDRINA_PLAN_GROUP_CODE = 'UNIMLOND'

// Corporate (Rede - Empresas)
export const ALBERT_EINSTEIN_PLAN_GROUP_CODE = 'HOISALEI'
export const DATTOS_PLAN_GROUP_CODE = 'DATTOS'
export const DEXTRA_PLAN_GROUP_CODE = 'GPL01009'
export const FUNDACAO_JOSE_LUIZ_EGIDIO_PLAN_GROUP_CODE = 'GPL01002'
export const HELLNER_PLAN_GROUP_CODE = 'GPL01007'
export const HELLNER_PROGRAMA_GUIAR_PLAN_GROUP_CODE = 'HEPRGU'
export const PILLAR_PLAN_GROUP_CODE = 'PILLAR'
export const PMESP_PLAN_GROUP_CODE = 'PMESP'
export const RESTOQUE_PLAN_GROUP_CODE = 'RESTOQUE'
export const ZUP_PLAN_GROUP_CODE = 'GPL01004'
export const COFCO_PLAN_GROUP_CODE = 'PROGCUID' // COFCO INTL - Nomeado como Programa Cuidar
export const ULTRALIGHT_PLAN_GROUP_CODE = 'ULTRALIG'

// Lista de planos que possuem o cadastro simples habilitado
export const PLAN_GROUPS_WITH_SIMPLE_SIGNUP_ENABLED = [
  ALICE_PLAN_GROUP_CODE,
  CASSI_PLAN_GROUP_CODE,
  CAREPLUS_PLAN_GROUP_CODE,
  CUIDAR_OMINT_PLAN_GROUP_CODE,
  OMINT_PLAN_GROUP_CODE,
  PMESP_PLAN_GROUP_CODE,
  SAMI_PLAN_GROUP_CODE,
  SANTA_HELENA_GROUP_CODE,
  UNIMED_ANHANGUERA_PLAN_GROUP_CODE,
  UNIMED_NOROESTE_PLAN_GROUP_CODE,
  UNIMED_LONDRINA_PLAN_GROUP_CODE
]
